import React from "react";
import "react-responsive-modal/styles.css";
import { Modal } from "react-responsive-modal";
import { ConfirmationContent } from "..";
import T from "prop-types";

export const TabletModal = ({
  open,
  title,
  content,
  contentDetail,
  subContent,
  onConfirm,
  onCancel,
  rightBtnText,
  titleIcon,
  cancelText,
  titleClass,
  isLoading
}) => {
  return (
    <Modal open={open} showCloseIcon={false} center onClose={onCancel}>
      <ConfirmationContent
        onCancel={onCancel}
        onConfirm={onConfirm}
        title={title}
        content={content}
        contentDetail={contentDetail}
        subContent={subContent}
        rightBtnText={rightBtnText}
        titleIcon={titleIcon}
        cancelText={cancelText}
        titleClass={titleClass}
        isLoading={isLoading}
      />
    </Modal>
  );
};

TabletModal.T = {
  onConfirm: T.func,
  onCancel: T.func,
  content: T.string,
  cancelText: T.string,
  titleClass: T.string,
};
